import axios from "axios";

let user = {
  id: null,
  lang: '',
};

const getters = {
  GET_DATA_USER: state => state.id,
  GET_DATA_LANG: state => state.lang,
};
const mutations = {
  RESET_DATA_USER(state) {
    state.id = null;
    state.lang = '';
  },
  SET_DATA_USER(state, data) {
    state.id = data.MID;
    state.lang = data.locale_id || data.lang;
  },
  SET_LANG(state, data) {
    state.lang = data;
  }
};

const actions = {
  initUser({ commit }) {
    return axios
      .get("/user/ajax/current-user-data")
      .then(response => {
        if (response.status === 200 && response.data)
          commit("SET_DATA_USER", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },
  logoutUser({ commit }) {
    axios.get("/logout").then(() => {
      commit("RESET_DATA_USER");
      window.location.href = "/";
    });
  }
};

export default {
  namespaced: true,
  state: user,
  getters,
  mutations,
  actions
};
